import { useDispatch, useSelector } from 'react-redux';
import { setStart, setTries } from './saturated.slice';
import dayjs from 'dayjs';

export const SATURATED_TIME_SECONDS = 180;
export const SATURATED_BOOKING_TIME_SECONDS = 300;
export const SATURATED_TRIES = 3;

export default function useSaturated() {
  const dispatch = useDispatch();
  const { tries, start } = useSelector((state) => state.saturated);
  const event = useSelector((state) => state.event || { event: {} });

  const setStartTime = () => {
    dispatch(setStart(dayjs().format()));
  };

  const decreaseTriesCounter = () => {
    dispatch(setTries(tries - 1));
  };

  return {
    tries,
    start,
    setStartTime,
    decreaseTriesCounter,
    isEnabled: event.is_saturated,
  };
}
